import type { CarelonProviderDirectoryFeatureFlagValues } from './types'

export enum CARELON_PROVIDER_DIRECTORY_PLACEMENTS {
  PROVIDER_RESULTS = 'providerResults',
  CONSOLIDATED_CARE_NAVIGATOR = 'consolidatedCareNavigator',
  ENHANCED_ZERO_RESULTS = 'enhancedZeroResults',
}

export enum CARELON_PROVIDER_DIRECTORY_TREATMENT_GROUPS {
  OUTPATIENT_THERAPY = 'outpatientTherapy',
  MEDICATION_MANAGEMENT = 'medicationManagement',
}

// Domain keys are mapped from LaunchDarkly values at the application boundary.
export enum CARELON_PROVIDER_DIRECTORY_FEATURE_FLAGS {
  OUTPATIENT_THERAPY = 'outpatientTherapy',
}

export const EMPTY_CARELON_PROVIDER_DIRECTORY_FEATURE_FLAGS: CarelonProviderDirectoryFeatureFlagValues = {}
